import { action, makeObservable, observable } from "mobx";
import { IRootStore } from "src/Shared/Stores/Root.store";
import { ISLAInfo } from "../Interfaces/ISLAInfo";

export class SLAManagementStore {
  rootStore: IRootStore;

  slaInfo: ISLAInfo;

  constructor(rootStore: IRootStore) {
    makeObservable(this, {
      slaInfo: observable,
      setSlaInfo: action,
    });
    this.rootStore = rootStore;
  }

  setSlaInfo = (slaInfo: ISLAInfo) => {
    this.slaInfo = slaInfo;
  };
}
